const Login = () => import('@pages/Login')
const Reg = () => import('@pages/Reg')
const QrCode = () => import('@pages/QrCode')
const Logout = () => import('@components/Logout')
const WxLogin = () => import('@components/WxLogin')
const WxTokenGetter = () => import('@components/WxTokenGetter')

export const auth = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {auth: false}
  },
  {
    path: '/reg',
    name: 'Reg',
    component: Reg,
    meta: {auth: false}
  },
  {
    path: '/qrcode',
    name: 'QrCode',
    component: QrCode,
    meta: {auth: false}
  },
  {
    path: '/logout',
    component: Logout
  },
  {
    path: '/wx_login',
    component: WxLogin,
    meta: {auth: false}
  },
  {
    path: '/get_wechat_token',
    component: WxTokenGetter,
    meta: {auth: false}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/auth.route.js